import { CaretDown } from "@phosphor-icons/react";

export function CollapsibleSection({ title, subtitle, icon, expanded, onToggle, children, testId, headerActions }) {
  return (
    <section className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-testid={testId}>
      <button
        type="button"
        onClick={onToggle}
        className="w-full px-6 py-4 flex items-center justify-between gap-3 hover:bg-slate-50/50 transition-colors"
        data-testid={`${testId}-toggle`}
      >
        <div className="flex items-center gap-3 min-w-0">
          {icon && (
            <div className="w-8 h-8 rounded-md bg-[#327de3]/10 text-[#327de3] flex items-center justify-center shrink-0">
              {icon}
            </div>
          )}
          <div className="text-left min-w-0">
            <h3 className="font-display text-lg font-semibold text-slate-900 truncate">{title}</h3>
            {subtitle && <div className="text-xs text-slate-500 mt-0.5">{subtitle}</div>}
          </div>
        </div>
        <div className="flex items-center gap-2 shrink-0">
          {headerActions}
          <CaretDown size={18} weight="bold" className={`text-slate-500 transition-transform duration-200 ${expanded ? "rotate-180" : ""}`} />
        </div>
      </button>
      {expanded && <div className="border-t border-slate-100">{children}</div>}
    </section>
  );
}
